import TravelRuleTableItemSubHeader from './TravelRuleTableItemSubHeader'

export default TravelRuleTableItemSubHeader
